import { api } from '../api/client';

/**
 * Fetch a server CSV endpoint (which sends raw text/csv via @Res, not the JSON envelope) and save it as
 * a file. Uses `api` (raw axios) with responseType 'text' so the body is the CSV, not an unwrapped object.
 */
export async function downloadCsv(url: string, filename: string): Promise<void> {
  const r = await api.get(url, { responseType: 'text' });
  const blob = new Blob([r.data], { type: 'text/csv;charset=utf-8' });
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { URL.revokeObjectURL(objectUrl); a.remove(); }, 100);
}
